export default __webpack_public_path__ + "static/media/PowerPoleMk3.256.d6a8e3e3.png";